import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

function Activation_Id_By_Zero_Pin() {
  const { userId } = useSelector((state) => state.Auth);
  const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [value, setActivation] = useState("");
  const [name, setName] = useState("");
  const [utr, setUtr] = useState("");

  const referral_API = async () => {
    if (search && value) {
      try {
        let responceRight = await API?.post(
          "/FundTransfer",
          {
            loginid: userId,
            uid: search,
            amount: value,
            utrNo: utr,
            type: "transfer",
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        console.log("My_Team", responceRight);
        if (responceRight.data.data == "Successfull") {
          toast.success("Fund Added Successfully.");
          setActivation("");
          setSearch("");
          setName("");
          setUtr("");
        } else {
          toast(responceRight.data.data.result);
        }
      } catch (e) {
        console.log("error Balance APi", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(
            updateAuth({ AdminAuth: false, jwt_token: "", userId: null })
          );
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };

  const Deduct_API = async () => {
    if (search && value) {
      try {
        let responceRight = await API?.post(
          "/FundTransfer",
          {
            loginid: userId,
            uid: search,
            amount: value,
            utrNo: utr,
            type: "deduct",
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        console.log("My_Team", responceRight);
        if (responceRight.data.data == "Successfull") {
          toast.success("Fund Added Successfully.");
          setActivation("");
          setSearch("");
          setName("");
          setUtr("");
        } else {
          toast(responceRight.data.data.result);
        }
      } catch (e) {
        console.log("error Balance APi", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(
            updateAuth({ AdminAuth: false, jwt_token: "", userId: null })
          );
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setSearch(limitedValue);
    member_Api(limitedValue);
  };

  const member_Api = async (value) => {
    try {
      let res = await API.get(`Getusername?uid=${value}`, {
        headers: {
          Authorization: jwt_token,
        },
      });
      console.log("member_Api", res.data.data.result);
      if (res.data.data.result) {
        setName(res.data.data.result);
      } else {
        setName("");
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Funds Transfer</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}>
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}></span>
                                <div className="d-flex justify-content-between">
                                  <h1>Funds Transfer</h1>
                                  <a
                                    href="/Funds_Details"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}>
                                    Funds History
                                  </a>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={search}
                                    onChange={handleChange}
                                  />
                                </div>
                                {name && (
                                  <div className="form-group">
                                    <label>Name</label>
                                    <input
                                      type="text"
                                      id="txtuid"
                                      class="form-control"
                                      value={name}
                                      readOnly
                                    />
                                  </div>
                                )}
                                <div className="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={value}
                                    onChange={(e) =>
                                      setActivation(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>UTR</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    maxLength={10}
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter UTR"
                                    value={utr}
                                    onChange={(e) => setUtr(e.target.value)}
                                  />
                                </div>
                                <div class="joinbtn d-flex  me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => referral_API()}>
                                    Fund Transfer
                                  </button>
                                </div>
                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Deduct_API()}>
                                    Fund Deduct
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Activation_Id_By_Zero_Pin;
